import React, { useEffect, useState } from 'react';
import { AnalyticsAPI } from '../mock';

// Non-intrusive pulsing pill that shows the number of visitors active on the
// site in the last 3 minutes. Refreshes every 30 seconds. Renders nothing
// when there are 0 (or 1 — that's just the current user) so we never
// display an embarrassingly quiet number.
export default function LiveVisitors({ className = '', minToShow = 2 }) {
  const [live, setLive] = useState(null);

  useEffect(() => {
    let alive = true;
    let timer;
    const tick = async () => {
      try {
        const { live: n } = await AnalyticsAPI.live();
        if (alive) setLive(n);
      } catch { /* silent */ }
    };
    tick();
    timer = setInterval(tick, 30000);
    return () => { alive = false; clearInterval(timer); };
  }, []);

  if (live == null || live < minToShow) return null;

  return (
    <div
      className={`inline-flex items-center gap-2 bg-white/95 backdrop-blur px-3 h-8 rounded-full border border-black/10 shadow-sm ${className}`}
      role="status"
      aria-live="polite"
      data-testid="live-visitors"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-70 animate-ping" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
      </span>
      <span className="text-[11px] font-semibold tracking-wide">
        <b>{live}</b> viewing now
      </span>
    </div>
  );
}
